export default {"src":"/pro/_next/static/media/hype.5b359ea9.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};